export default "__VITE_ASSET__BVoeBXbB__"